<form
  class="field-dialog__content__scroll p-24"
  fxLayout="column"
  name="form"
  [formGroup]="segmentsSettingsForm"
  fusePerfectScrollbar
>
  <div class="card" fxLayout="column">
    <div fxLayout="row">
      <mat-slide-toggle
        [title]="'SEGMENTS.DIALOG.SETTINGS.SET_MAINTENANCE_TYPES_SLIDER' | translate"
        class="mat-toggle-position"
        formControlName="linkMaintenanceTypesToSegment"
      >
        {{ 'SEGMENTS.DIALOG.SETTINGS.SET_MAINTENANCE_TYPES_SLIDER' | translate }}
      </mat-slide-toggle>
    </div>
    <fc-maintenance-types-input
      [control]="maintenanceTypesForm.get('maintenanceTypes')"
      [requiredMark]="requiredMark"
      *ngIf="segmentsSettingsForm.get('linkMaintenanceTypesToSegment').value"
      shouldDisplayArchived="true"
    ></fc-maintenance-types-input>

    <mat-error *ngIf="noMaintenanceTypesSelected">
      {{ 'SEGMENTS.DIALOG.SETTINGS.MAINTENANCES_REQUIRED_FIELD_ERROR' | translate }}
    </mat-error>
  </div>
</form>
